import { CreateService, CRUDServiceInterface } from '@/services/service';
import { IssueCommentReactionEntity } from '@/entities/issue-comment-reaction.entity';

export default class IssueCommentReactionService
  extends CreateService<IssueCommentReactionEntity>('issue-comment-reaction')
  implements CRUDServiceInterface<IssueCommentReactionEntity>
{
  async getMany(
    commentId: string | number,
    emoticonId: string | number,
  ): Promise<IssueCommentReactionEntity[]> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('commentId', '$eq', String(commentId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
